import {FC} from 'react'
import {Redirect} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {UserModel} from '../../modules/auth/models/UserModel'
import {UserRole} from '../../constants/roles'
import {hasRole} from '../../utils/permissions'
import {PromoBannersAdminPage} from './PromoBannersAdminPage'

const PromoBannersAdminWrapper: FC = () => {
  const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  if (!hasRole(user, UserRole.ADMIN)) {
    return <Redirect to='/' />
  }

  return <PromoBannersAdminPage />
}

export {PromoBannersAdminWrapper}
